import { useId } from "react"

import { ClassSearchProvider } from "@/components/search/classes/class-search-provider"
import { ClassSearchFacets } from "@/components/search/classes/class-search-sidebar"
import {
  ClassResultCard,
  ClassResultContent,
  ClassResultDetails,
  ClassResultFooter,
  ClassResultHeader,
  ClassResultSpecialities,
  ClassSearchResults,
} from "@/components/search/classes/class-result"
import { SearchTabs } from "@/components/search/search-layout"
import { SearchWorkspace } from "@/components/search/search-workspace"
import { FullTextFilter } from "@/components/search/full-text-filter"
import { SearchUrlState } from "@/lib/redux-search/search-url-state"

export default function Page() {
  return (
    <ClassSearchProvider>
      <SearchUrlState />
      <SearchWorkspace>
        <SearchWorkspace.Sidebar>
          <ClassSearchFacets />
        </SearchWorkspace.Sidebar>
        <SearchWorkspace.Content>
          <SearchTabs />
          <FullTextFilter
            fields={[
              "class_details.name^3",
              "class_details.name.autocomplete^2",
              "class_details.name.keyword^5",
              "profile_details.name^3",
              "profile_details.name.autocomplete^2",
              "profile_details.name.keyword^5",
              "keywords",
              "keywords.keyword",
            ]}
            filterId="class_name"
          />
          <ClassSearchResults ResultComponent={Result} />
        </SearchWorkspace.Content>
      </SearchWorkspace>
    </ClassSearchProvider>
  )
}

function Result({ result }: { result: any }) {
  const titleId = useId()

  return (
    <ClassResultCard titleId={titleId}>
      <ClassResultHeader result={result} titleId={titleId} />
      <ClassResultContent>
        <ClassResultDetails result={result} />
        <ClassResultSpecialities result={result} />
      </ClassResultContent>
      <ClassResultFooter result={result} />
    </ClassResultCard>
  )
}
